module.exports = __webpack_public_path__ + "static/media/singapore-airlines.33c6a43e.png";